import { client } from './base'

class GenericApi {
  getProfile = () => client.get('/api/me')
  logout = () => client.post('/api/logout')
  register = (token, payload) =>
    client.post('/api/registrations', { ...payload, course_token: token })

  getCourse = (token) => client.get(`/api/courses/${token}/info`)
  getCountry = () => client.get('/api/countries')
  getWorkstation = (token) => client.get(`/api/workstations/${token}/info`)
  deleteParticipant = (id) => client.delete(`/api/participants/${id}`)
  getCourseParticipantSessions = (id, params) =>
    client.get(`/api/courses/${id}/participant-sessions`, { params })

  getAppstreamSessions = (params) =>
    client.get('/api/courses/appstream-sessions', { params })

  getParticipantSessions = (params) =>
    client.get('/api/participant-sessions', { params })
}

export const apiCheckWorkstationPasskey = (token) =>
  client.get(`/api/workstations/${token}/passkey`)

export const getWorkstationStreamingUrl = (token, assertion) =>
  client.post(`/api/workstations/${token}`, {
    assertion
  })

export async function getRegistration(id) {
  const response = await client.get(`/api/registrations/${id}`)

  return response.data
}

export default new GenericApi()
